module.exports = new __parcel__URL__("people-group.ca915bcd.svg").toString();